import RegistrationService from "@/services/RegistrationService";

const state = () => ({
    promoterDefaultId: null,
    promoterDefaultUserId: null,
    promoterSelData: null,
    promoterList: []
});

const mutations = {
    setPromoterDefaultId(state, value) {
        state.promoterDefaultId = value;
    },
    setPromoterDefaultUserId(state, value) {
        state.promoterDefaultUserId = value;
    },
    setPromoterSelData(state,value) {
        state.promoterSelData = value;
    },
    setPromoterList(state,value) {
        state.promoterList = value;
    }
}

const getters = {
    getPromoterDefaultId() { 
        return state.promoterDefaultId;
    },
    getPromoterDefaultUserId() { 
        return state.promoterDefaultUserId;
    },
    getPromoterSelData() {
        return state.promoterSelData;
    },
    getPromoterList() {
        return state.promoterList;
    }
}

const actions = {
    getPromoterAction({ commit }, promoterId) {
        RegistrationService.getPromoterbyId(promoterId).then((resp) => {
            if(resp && resp.data && resp.data.success) {
                const data = resp.data.message;
                if(Array.isArray(data) && data.length == 1) {
                    commit('setPromoterDefaultId', data[0].promoterId);
                    commit('setPromoterDefaultUserId', data[0].userID);
                    commit('setPromoterSelData', data[0]);
                }
                commit('setPromoterList', data);
            }
        });
    }
}

export default {
    state, mutations, actions, getters
}